import styled from "styled-components";

export const PerformerAboutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 1000px;
`;
